// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d6WCD","questions":"styles_questions__1MLlS","footer":"styles_footer__UvJrR"};